<template>
    <app-wrapper>
        <app-header :loan="loan" medium-max-width="max-w-1000">
            <template #top>
                <div class="w-full flex items-center">
                    <div class="flex-auto">
                        Your desired loan amount
                        <h2 class="mb-0 mt-2 md:mt-4 md:text-6xl">{{ loan.amount | money(0) }}</h2>
                    </div>
                    <div class="flex-initial">
                        <i class="fa fa-check-circle text-success text-7xl"/>
                    </div>
                </div>
            </template>
        </app-header>
        <app-body medium-max-width="max-w-1000">

            <template #title>
                <span>Your approval is currently expired.</span>
            </template>

            <template #text>
                If you would like to discuss your options, have questions, or need assistance please <a href="/contact" target="_blank" class="text-black">contact us.</a>
            
                <!-- Use the ReApplyButton component -->
                <ReApplyButton 
                    :loan="loan"
                />
            </template>

        </app-body>
    </app-wrapper>
</template>

<script>
import { mapGetters } from 'vuex';
import ReApplyButton from '../../../components/ReApplyButton.vue';

export default {
    mixins: [require('../../../mixins/InteractsWithGtag').default],

    components: {
        ReApplyButton
    },

    props: ['loan'],

    data() {
        return {
            gTagPageName: 'loan-pending',
        }
    },

    created() {
        this.gTagEvent('loan-expired', {
            event_category: 'onboarding',
            event_label: 'loan-expired',
        });
    },

    computed: {
        ...mapGetters([
            'getAmountByState'
        ]),

        getDefaultAmounts() {
            let amounts = this.getAmountByState();
            return amounts;
        }
    }
}
</script>
